<div class="app-album-list" *ngIf="is_can_see_album"
    [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null  }">
    <div class="album-box"
        [ngStyle]="{'background-color': settingsData.bg_secondary_color ? settingsData.bg_secondary_color :  null, 'font-family': settingsData.font_family ? settingsData.font_family : null  }">
        <span (click)='goToGener()' class="backbtn pointer"
            [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null ,'font-size': settingsData.fs_sub_title ? settingsData.fs_sub_title : null }">
            <i class="fa fa-angle-left"></i>
            <span class="ml-5 d-none d-md-inline-block">Back</span>
        </span>
        <!-- audio start -->
        <div class="mt-10 row align-items-center">
            <!-- Thumbnail image starts -->
            <div class="col-6 col-lg-3">
                <div *ngIf="streamInfo.video_thumbnail_image"
                    [ngStyle]="{'background-image': 'url('+ streamInfo.video_thumbnail_image +')','background-color': settingsData.font_primary_color ? settingsData.font_primary_color : null}"
                    class="br-10 a-image">
                </div>
                <span *ngIf="!streamInfo.video_thumbnail_image" width="100%" class="w-img">
                    <app-svg [icon]="'Audio_display'"></app-svg>
                </span>
                <!-- <img *ngIf="!streamInfo.video_thumbnail_image" [src]="assets_url + 'album-cover.svg'" width="100%" class="w-img"> -->
            </div>
            <!-- Thumbnail image ends -->
            <div class=" col-12 col-md-6 col-lg-9">
                <div class="fs-30 fsr-30 pb-2 lh-30 lhr-30 m-t-res-15"
                    [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }">
                    {{streamInfo.stream_video_title}}
                </div>
                <div [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }">
                    <span>{{streamInfo.subData }}</span>
                    <span *ngIf="streamInfo.subData && streamInfo.subData_Release"
                        [ngStyle]="{'background-color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }"
                        class="small">
                    </span>
                    <span>{{streamInfo.subData_Release}}</span>
                </div>
                <!-- Play button starts here -->
                <div class="h-50 mt-5" *ngIf="!showCountDownTimer">
                    <span>
                        <button mat-flat-button [hidden]="tag_category == 'recorded-video'" [disabled]="enablePlay || router.url.includes('/preview') ||
              (streamInfo.stream_payment_mode=='subscription' && showAlbumSubscriptionButton)"
                            class="flat-primary-buttonp  mr-20" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
             'font-family': settingsData.font_family ? settingsData.font_family : null  }" *ngIf="subEvents.length > 0"
                            (click)="playFromBanner(template)">
                            Play
                        </button>
                    </span>
                    <!-- Subscription collection marker beside Play (display only, QA 2026-10-09) -->
                    <span class="album-sub-chip mr-20" *ngIf="streamInfo.stream_payment_mode == 'subscription'"
                        [class.is-on]="userInfo?.access_token && !showAlbumSubscriptionButton && subscribedUserPlans?.length"
                        [ngStyle]="{'color': settingsData?.font_primary_color ? settingsData.font_primary_color : null}">
                        {{ userInfo?.access_token && !showAlbumSubscriptionButton && subscribedUserPlans?.length ? 'Subscribed' : 'Subscription' }}
                    </span>
                    <!-- Album paid button -->
                    <span class="pointer " (click)="doSubscribePayment(streamInfo,true,'album')"
                        *ngIf="streamInfo.stream_payment_mode=='subscription' && showAlbumSubscriptionButton && !router.url.includes('/preview') && streamInfo.stream_payment_mode!='paid' && streamInfo.stream_payment_mode!='free'"
                        matTooltip="Subscribe" matTooltipPosition='above'>
                        <app-svg [icon]="'subscribtion'" [color]="settingsData?.font_primary_color ? settingsData?.font_primary_color : '#ffffff'" 
                        [backgroundColor]="settingsData.bg_primary_color ? settingsData.bg_primary_color : null"></app-svg>
                    </span>
                    <!-- Album subscription button -->
                    <span class="pointer " (click)="openVideoAudioPayment(streamInfo,'album')"
                    *ngIf="streamInfo.stream_payment_mode=='paid' && showAlbumPaymentButton && !router.url.includes('/preview')  && streamInfo.stream_payment_mode!='subscription' && streamInfo.stream_payment_mode!='free'"
                        matTooltip="Buy Album" matTooltipPosition='above'>
                        <app-svg [icon]="'album_purchase'" [color]="settingsData?.font_primary_color ? settingsData?.font_primary_color : '#ffffff'" 
                        [backgroundColor]="settingsData.bg_primary_color ? settingsData.bg_primary_color : null"></app-svg>
                    </span>
                    <!-- Tips button -->
                    <span class="pointer" (click)="openTips()"
                        *ngIf="!router.url.includes('/preview')">
                        <span class=" "
                            *ngIf="streamInfo.tip_donation==1 || (streamInfo.tip_donation!=0 && streamInfo.tip_donation!=1 && streamInfo.tip_donation!=2 && performer_details['tip_donation'] == 1)"
                            matTooltipPosition='above' matTooltip="Tips">
                            <app-svg [icon]="'live-stream-tip-icon1'" [color]="settingsData?.font_primary_color ? settingsData?.font_primary_color : '#ffffff'" 
                            [backgroundColor]="settingsData.bg_primary_color ? settingsData.bg_primary_color : null"></app-svg>
                        </span>
                        <span class=" "
                            *ngIf="streamInfo.tip_donation ==2 || (streamInfo.tip_donation!=0 && streamInfo.tip_donation!=1 && streamInfo.tip_donation!=2 && performer_details['tip_donation'] == 2)"
                            matTooltipPosition='above' matTooltip="Donations">
                            <app-svg [icon]="'live-stream-donation-icon1'" [color]="settingsData?.font_primary_color ? settingsData?.font_primary_color : '#ffffff'"
                            [backgroundColor]="settingsData.bg_primary_color ? settingsData.bg_primary_color : null"></app-svg>
                        </span>
                    </span>
                    <!-- Polls Button -->
                    <span class="pointer " matTooltip="Polls" matTooltipPosition='above' (click)="openPolls()"
                        *ngIf="streamInfo.vod_video_audio=='audio'  && (streamInfo && streamInfo.polls && streamInfo.polls.length>0 && !router.url.includes('/preview'))">
                        <app-svg [icon]="'album-poll1'" [color]="settingsData?.font_primary_color ? settingsData?.font_primary_color : '#ffffff'"
                        [backgroundColor]="settingsData.bg_primary_color ? settingsData.bg_primary_color : null"></app-svg>
                    </span>
                    <span class="pointer " matTooltip="Polls" matTooltipPosition='above' (click)="openPolls('Poll')"
                        *ngIf="streamInfo.vod_video_audio=='video' && (subEvents && subEvents[0]?.stream_info?.polls && subEvents[0]?.stream_info?.polls?.length >0 && !router.url.includes('/preview'))">
                        <app-svg [icon]="'album-poll1'" [color]="settingsData?.font_primary_color ? settingsData?.font_primary_color : '#ffffff'"
                        [backgroundColor]="settingsData.bg_primary_color ? settingsData.bg_primary_color : null"></app-svg>
                    </span>
                </div>
                <!-- Play button ends here -->
                <!-- ------------dates div starts here--------------------------------------------- -->
                    <div class="col-12 col-md-6 col-lg-9">
                        <!-- ------------dates div starts here--------------------------------------------- -->
                        <div class="dates-overall" [hidden]="tag_category != 'recorded-video'">
                            <div class="left-arrow dates-arrows"
                                [ngStyle]="{'background-color': settingsData?.bg_secondary_color ? settingsData?.bg_secondary_color : '#000'  }"
                                (click)="scrollDatesLeft()" *ngIf="leftScroll">
                                <i class="fa fa-angle-left"
                                    [ngStyle]="{'color': settingsData?.font_primary_color ? settingsData?.font_primary_color : null }"></i>
                            </div>
                            <div class="right-arrow dates-arrows" (click)="scrollDatesRight()"
                                [ngStyle]="{'background-color': settingsData?.bg_secondary_color ? settingsData?.bg_secondary_color : '#000' }"
                                *ngIf="rightScroll">
                                <i class="fa fa-angle-right"
                                    [ngStyle]="{'color': settingsData?.font_primary_color ? settingsData?.font_primary_color : null }"></i>
                            </div>
                            <div class="dates-container" [ngClass]="{'plr-5' : !rightScroll && !leftScroll }"
                                id="dates-container"
                                [ngStyle]="{'border-color': settingsData?.font_primary_color ? settingsData?.font_primary_color : '#fff' }">
                                <div class="dates pointer" *ngFor="let date of datesList; let selected = index;"
                                    (click)="onChangeDate(date,selected)"
                                    [ngStyle]="{'background-color': selectedDateIndex == selected ? settingsData?.bg_primary_color ? settingsData?.bg_primary_color : '#222C36' : '','border-color' : settingsData?.font_primary_color ? settingsData?.font_primary_color: '#fff'  }">
                                    <div
                                        [ngStyle]="{'color': settingsData.font_primary_color ? settingsData.font_primary_color : '#fff' }">
                                        {{date.start}}
                                    </div>
                                    <div
                                        [ngStyle]="{'color': settingsData.font_primary_color ? settingsData.font_primary_color : '#fff' }">
                                        {{date.day}}</div>
                                </div>
                            </div>
                        </div>
                        <!-- ------------dates div ends here--------------------------------------------- -->
                    </div>
                <!-- audio ends -->
                <!-- Album drop timer starts here -->
                <div class="mt-15">
                    <div class="app-count-down-timer p-10" *ngIf="showCountDownTimer">
                        <div class="fs-16 pt-5 pl-5">
                            Sale starts in ...
                        </div>
                        <div class="row no-gutters">
                            <div class="days">
                                <div class="fs-15 mt-15">{{days}}</div>
                                <div class="mt-5 days-label">
                                    <span *ngIf="days!=1">Days</span>
                                    <span *ngIf="days==1">Day</span>
                                </div>
                            </div>
                            <div class="hours">
                                <div class="fs-15 mt-15">{{hours}}</div>
                                <div class="mt-5 days-label">
                                    <span *ngIf="hours!=1">Hours</span>
                                    <span *ngIf="hours==1">Hour</span>
                                </div>
                            </div>
                            <div class="minutes">
                                <div class="fs-15 mt-15">{{minutes}}</div>
                                <div class="mt-5 days-label">
                                    <span *ngIf="minutes!=1">Minutes</span>
                                    <span *ngIf="minutes==1">Minute</span>
                                </div>
                            </div>
                            <div class="seconds">
                                <div class="fs-15 mt-15">{{seconds}}</div>
                                <div class="mt-5 days-label">Seconds</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Album drop timer ends here -->
            <!-- ---------------- Audio List -------------------- -->
            <div class="text-right ad-right-learn-more" *ngIf="showAdright">
                <div class="d-inline-block relative">
                    <div [innerHTML]="adVideoright" alt=' ' title=' ' class="adright text-center">
                    </div>
                    <span class="icon-bg mr-2 left-top">
                        <a class="text-center" *ngIf="!router.url.includes('/preview')" [href]="selectedAdRightData"
                            target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i
                                class="fa fa-external-link fs-9 ml-4"></i></a>
                        <a class="text-center" *ngIf="router.url.includes('/preview')"
                            class="mr-2 text-white text-decoration-none slick-disabled">Learn more <i
                                class="fa fa-external-link fs-9 ml-4"></i></a>
                    </span>
                </div>
            </div>
            <div class="text-center p-20 w-100" *ngIf="showAdCenter">
                <div class="d-inline-block relative">
                    <div [innerHTML]="adVideoCenter" alt=' ' title=' ' class="adcenter text-center">
                    </div>
                    <span class="icon-bg mr-2 left-top">
                        <a class="text-center" *ngIf="!router.url.includes('/preview')" [href]="selectedAdCenterData"
                            target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i
                                class="fa fa-external-link fs-9 ml-1"></i></a>
                        <a class="text-center" *ngIf="router.url.includes('/preview')"
                            class="mr-2 text-white text-decoration-none slick-disabled">Learn more <i
                                class="fa fa-external-link fs-9 ml-1"></i></a>
                    </span>
                </div>
            </div>
            <div [hidden]="tag_category != 'audio'" class="table-responsive table-custom-style p-25 pt-4"
                [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null  }">

                <table mat-table [dataSource]="dataSource" class="w-100 mb-180"
                    [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null  }">

                    <ng-container matColumnDef="Play">
                        <th mat-header-cell *matHeaderCellDef class="pl-15 "> Play </th>
                        <td mat-cell *matCellDef="let element;let i = index;" class="pl-15 rpl width-row"
                        >
                            <!-- Audio play button -->
                            <div *ngIf="!showCountDownTimer">
                                <ng-container *ngIf="!element.isAudioPlaying">
                                    <ng-container *ngIf="(((
                        (!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
                        element.stream_info.stream_payment_mode == 'free_ads' || element.isSubscribed || element.isPurchased)
                        && !router.url.includes('/preview') || (element.stream_info.stream_payment_mode == 'paid' && element.isPurchased)
                        && !element.isAudioPlaying )

                        || (streamInfo.stream_payment_mode == 'paid'&& element.stream_info.stream_payment_mode =='paid' && element.isPurchased)
                        || (streamInfo.stream_payment_mode == 'paid'&& element.stream_info.stream_payment_mode =='subscription' && (element.isSubscribed||!showAlbumPaymentButton)))
                        || (streamInfo.stream_payment_mode == 'paid'&&!showAlbumPaymentButton))

                        &&(streamInfo.stream_payment_mode != 'subscription')&&(element.stream_info.stream_payment_mode != 'subscription')
                        ">
                                        <div id="playVideo{{element.stream_info.id}}" class="media-ply-stop-btn pointer"
                                            (click)="toggleAudio(element,i)">
                                            <i class="fa fa-play player-icon play-icon" aria-hidden="true"></i>
                                        </div>
                                    </ng-container>

                                    <!-- Audio play button For subscription -->
                                    <ng-container *ngIf="(streamInfo.stream_payment_mode=='subscription' && !showAlbumSubscriptionButton)
                            ||(element.stream_info.stream_payment_mode == 'subscription' && element.isSubscribed)
                            ||(streamInfo.stream_payment_mode == 'paid'&& element.stream_info.stream_payment_mode =='subscription' && (element.isSubscribed||!showAlbumPaymentButton))
                            ">
                                        <!-- <div id="playVideo{{element.stream_info.id}}" class="media-ply-stop-btn pointer"
                                            (click)="toggleAudio(element,i)">
                                            <i class="fa fa-play player-icon play-icon" aria-hidden="true"></i>
                                        </div> -->
                                    </ng-container>

                                    <ng-container
                                        *ngIf="(!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
                            element.stream_info.stream_payment_mode == 'free_ads' || element.isSubscribed) && router.url.includes('/preview')">
                                        <!-- <img src="assets/channel-album/play.svg" class="slick-disabled"> -->
                                        <div class="media-ply-stop-btn">
                                            <i class="fa fa-play player-icon play-icon slick-disabled"
                                                aria-hidden="true"></i>
                                        </div>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="element.stream_info.stream_payment_mode == 'paid' && !element.isPurchased && router.url.includes('/preview')">
                                        <!-- <img [src]="assets_url+'channel-album/single-pay.svg'" class="slick-disabled"> -->
                                        <span class="slick-disabled dollar-icon">
                                            <app-svg [icon]="'channel-album-single-pay'" [color]="i % 2 == 0 ? settingsData?.font_tertiary_color : settingsData?.bg_tertiary_color"></app-svg>
                                        </span>
                                    </ng-container>
                                    <!-- Audio Payment button -->
                                    <ng-container *ngIf="((element.stream_info.stream_payment_mode == 'paid' && !element.isPurchased && !router.url.includes('/preview')
                                && streamInfo.stream_payment_mode!='subscription' && streamInfo.stream_payment_mode!='free')
                                || (streamInfo.stream_payment_mode=='paid'&&showAlbumPaymentButton && element.stream_info.stream_payment_mode == 'paid' && !element.isPurchased ))
                                && !(streamInfo.stream_payment_mode=='paid'&& !showAlbumPaymentButton)

                                ">
                                        <!-- <img [src]="assets_url+'channel-album/single-pay.svg'" class="pointer"
                                id="playVideo{{element.stream_info.id}}" (click)="openVideoAudioPayment(element)"> -->
                                        <span class="pointer dollar-icon" id="playVideo{{element.stream_info.id}}"
                                            (click)="openVideoAudioPayment(element)">
                                            <app-svg [icon]="'channel-album-single-pay'" [color]="i % 2 == 0 ? settingsData?.font_tertiary_color : settingsData?.bg_tertiary_color"></app-svg>
                                            <span class="track-price" *ngIf="element | vdTrackPrice: tickets as price">{{ price }}</span>
                                        </span>

                                    </ng-container>
                                    <ng-container
                                        *ngIf="element.stream_info.stream_payment_mode == 'subscription' && router.url.includes('/preview')">
                                        <div class="media-ply-stop-btn" [ngStyle]="{'background-color':settingsData?.bg_secondary_color}">
                                            <i class="fa fa-hand-o-up player-icon play-icon pl-0 slick-disabled" 
                                                aria-hidden="true"></i>
                                        </div>
                                        <!-- <img src="assets/channel-album/subscribe.svg" class="slick-disabled"> -->
                                    </ng-container>
                                    <!-- Audio Subscription button -->
                                    <ng-container
                                        *ngIf="((element.stream_info.stream_payment_mode == 'subscription' && !element.isSubscribed && !element.planNotSuff && !router.url.includes('/preview') && subscribedUserPlans.length == 0)
                            || ((streamInfo.stream_payment_mode=='subscription'&&showAlbumSubscriptionButton &&  subscribedUserPlans.length == 0)
                            || (streamInfo.stream_payment_mode=='paid' && element.stream_info.stream_payment_mode == 'subscription' && !element.isSubscribed  && subscribedUserPlans.length == 0))
                            ) && !element.isSubscribed && !(streamInfo.stream_payment_mode=='paid' && !showAlbumPaymentButton)">
                                        <div class="media-ply-stop-btn" >
                                            <i class="fa fa-hand-o-up player-icon play-icon pl-0" 
                                                id="playVideo{{element.stream_info.id}}" aria-hidden="true"
                                                (click)="doSubscribePayment(element,true)"></i>
                                        </div>
                                        <!-- <img src="assets/channel-album/subscribe.svg" class="pointer"
                                (click)="doSubscribePayment(element)"> -->
                                    </ng-container>
                                    <!-- Plan not sufficient Button -->
                                    <ng-container *ngIf="element.stream_info.stream_payment_mode == 'subscription' && element.planNotSuff && subscribedUserPlans.length > 0 && !router.url.includes('/preview')
                            && streamInfo.stream_payment_mode!='free'
                            && !(streamInfo.stream_payment_mode == 'paid' && !showAlbumPaymentButton)
                            && !(streamInfo.stream_payment_mode == 'subscription' && !showAlbumSubscriptionButton)
                            ">
                                        <!-- (click)="doSubscribePayment(element)" -->
                                        <div class="media-ply-stop-btn" >
                                            <i class="fa fa-hand-o-up pl-0 player-icon play-icon slick-disabled "
                                                id="playVideo{{element.stream_info.id}}" aria-hidden="true"
                                                matTooltip="Your current subscription plan is not sufficient for this song"
                                                matTooltipPosition='above'></i>
                                        </div>
                                        <!-- <img src="assets/channel-album/subscribe.svg"
                                matTooltip="Your current subscription plan is not sufficient for this song"
                                matTooltipPosition='above' class="slick-disabled"> -->
                                    </ng-container>
                                    <!-- Audio folder button -->
                                    <ng-container *ngIf="(streamInfo.stream_payment_mode=='paid'
                        && showAlbumPaymentButton && element.stream_info.stream_payment_mode == 'folder')">
                                        <div class="media-ply-stop-btn">
                                            <i class="fa fa-play player-icon play-icon slick-disabled"
                                                aria-hidden="true"
                                                matTooltip="Complete album payment to play the track"
                                                matTooltipPosition='above'></i>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="element.isAudioPlaying">
                                    <div class="media-ply-stop-btn">
                                        <i class="fa fa-pause player-icon stop-icon" aria-hidden="true"
                                            (click)="toggleAudio(element,i,'pause')"></i>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Audio timer button if timer is running -->
                            <div class="media-ply-stop-btn" *ngIf="showCountDownTimer">
                                <i class="fa fa-clock-o player-icon clock-icon" aria-hidden="true"
                                    matTooltip="Sale not started yet" matTooltipPosition='above'></i>
                            </div>
                        </td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="Index">
            <th mat-header-cell *matHeaderCellDef> Index </th>
            <td mat-cell *matCellDef="let element;let i = index;" class="pl-2 pt-5 ptr-5 aligntop width-row">
                <span
                    [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }">
                    {{element.metadata.track_number < 10 ? '0'+ element.metadata.track_number : element.metadata.track_number }} </span>
            </td>
        </ng-container> -->
                    <ng-container matColumnDef="Album">
                        <th mat-header-cell *matHeaderCellDef> Album </th>
                        <td mat-cell *matCellDef="let element" class="pl-1"
                      >
                            <span>
                                {{element.metadata.track_number < 10 ? '0' + element.metadata.track_number :
                                    element.metadata.track_number }} - {{element?.stream_info?.stage}} </span>
                                    <span class="d-block fs-12">
                                        Age Limit : {{element?.stream_info?.ageInfo}}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Views">
                        <th mat-header-cell *matHeaderCellDef>Views</th>
                        <td mat-cell *matCellDef="let element; let i=index" class="mintues-width-row"
                     >

                            <div class="text-center row no-gutters w-100 mt-5 like-share-icons"
                                style="position: relative;">
                                <span class="col-4">
                                    <div class="fs-20"><i class="fa fa-eye"></i></div>
                                    <div class="fs-10" matTooltip="{{element.stream_info['user_views']| number }} views"
                                        matTooltipPosition="above">
                                        <span *ngIf="element.stream_info && element.stream_info['user_views']>=0">
                                            {{element.stream_info['user_views'] | abbreviatedNumber}}
                                        </span>
                                    </div>
                                </span>
                                <span class="pointer col-4" *ngIf="!showCountDownTimer">
                                    <div class="fs-20"
                                        (click)="userInfo && userInfo.access_token ? likeAudioVideo(element,i): requireLogin()"
                                        matTooltip="Like" matTooltipPosition="above"
                                        [matTooltipDisabled]="element['stream_info'].is_liked == 1">
                                        <!-- <i class="fa fa-thumbs-up"
                                            [ngStyle]="{'color': (element['stream_info'].is_liked == 1) ? themeColors.primaryColor : themeColors.secondaryFontColor }"></i> -->
                                            <i class="fa fa-thumbs-up"></i>
                                    </div>
                                    <div class="fs-10">
                                        <span *ngIf="element.stream_info && element.stream_info['user_likes']>=0">
                                            {{element.stream_info['user_likes'] | abbreviatedNumber}}
                                        </span>
                                    </div>
                                </span>
                                <span class="pointer col-4" (click)="shareVideo(element)"
                                    (click)="$event.stopPropagation()">
                                    <!-- <div class="fs-20"><i class="fa fa-share-alt"
                                            [ngStyle]="{'color': element.shareSubEvent? themeColors.primaryColor : themeColors.secondaryFontColor }"></i>
                                    </div> -->
                                    <div class="fs-20"><i class="fa fa-share-alt"></i>
                                    </div>
                                    <!-- <div class="fs-10"
                                        [ngStyle]="{'color': element.shareSubEvent? themeColors.primaryColor : themeColors.secondaryFontColor }">
                                        Share</div> -->
                                    <div class="fs-10">Share</div>
                                </span>
                                <div *ngIf="element.shareSubEvent" #menu class="social-icons-div"
                                    (click)="$event.stopPropagation()">
                                    <app-social-share-link [slugName]="router.url+'?id='+element.stream_info.id"
                                        [sharedFrom]="'album'" [settingsData]="settingsData ? settingsData :'' "  (closeShareEvent)="closeSocialSharePopup($event)">
                                    </app-social-share-link>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Mintues">
                        <th mat-header-cell *matHeaderCellDef> Mintues </th>
                        <td mat-cell *matCellDef="let element" class="mintues-width-row"
                    >
                            <span class="mr-20" >
                                {{element?.stream_info?.duration}}
                            </span>
                            <div class="dropdown d-inline-block playlist-dd mr-20" *ngIf="userInfo.access_token && (
                        (!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
                        element.stream_info.stream_payment_mode == 'free_ads' || element.isSubscribed || element.isPurchased)
                        ||(streamInfo.stream_payment_mode == 'paid' && !showAlbumPaymentButton)
                        ||(streamInfo.stream_payment_mode == 'subscription' && !showAlbumSubscriptionButton)
                        && !router.url.includes('/preview')
                        )">
                                <button class="btn btn-secondary plus-icon text-center" id="dropdownMenu2"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                    [ngStyle]="{'background-color':settingsData?.bg_secondary_color,'color':settingsData?.font_primary_color}">
                                    <span class="plus-text align-middle"
                                        matTooltip="Add to playlist" matTooltipPosition="above">+</span>
                                </button>
                                
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2" [ngStyle]="{'background-color':settingsData?.form_bg_color , 'color':settingsData?.form_font_secondary_color}">
                                    <div class="dropdown-item pointer "
                                        (click)="createPlayList('audio')"><span class="fs-22 fw-400">+</span> Create New
                                        Playlist</div>
                                    <div class="creatediv" *ngIf="playListAry && playListAry.length > 0">
                                        <ng-container *ngFor="let playList of playListAry">
                                            <div class="dropdown-item pointer"
                                                (click)="addToPlayList(element, playList)">{{playList.playlist_name}}
                                            </div>
                                        </ng-container>
                                    </div>

                                </div>
                            </div>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Menu">
                        <th mat-header-cell class="w-80p" *matHeaderCellDef> Menu </th>
                        <td mat-cell class="w-80p text-right" *matCellDef="let element; let i=index"
                        >
                            <span class="pointer menu-div" (click)="$event.stopPropagation()">
                                <div mat-icon-button [ngClass]="{'slick-disabled':router.url.includes('/preview')}">
                                    <mat-icon class="mt-5" (click)="openMenu(i, element.openMenu)">more_vert</mat-icon>
                                    <div class="main-menu" (click)="reportFileData(element, 'audio')"
                                        *ngIf="element.openMenu"
                                        [ngStyle]="{'background-color':settingsData?.form_bg_color , 'color':settingsData?.form_font_secondary_color}">
                                        <div class="plr-10">Report</div>
                                        <div class="plr-10"><i class="fa fa-flag"></i></div>
                                    </div>
                                </div>
                            </span>
                        </td>
                    </ng-container>
                    <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                    'font-family': settingsData.font_family ? settingsData.font_family : null  }"></tr> -->
                    <ng-container *ngIf="false">
                        <tr mat-header-row *matHeaderRowDef="displayedColumns" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                    'font-family': settingsData.font_family ? settingsData.font_family : null  }"></tr>
                    </ng-container>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index;"
                    [style.background-color]="(i % 2 == 0 ? settingsData.bg_tertiary_color : settingsData.font_tertiary_color) + ' !important'"
                    [style.color]="(i % 2 == 0 ? settingsData.font_tertiary_color : settingsData.bg_tertiary_color) + ' !important'"
                    [style.font-family]="(settingsData.font_family || 'inherit') + ' !important'"></tr>
                </table>
                <!-- <div [hidden]="!showAd" class="full-page-ad text-center" *ngIf="tag_category == 'audio'">
        <div class="ablum-ads" data-closable>
            <div [innerHTML]="adVideo" alt=' ' title=' ' class="ad bg-dark" *ngIf="showAd"></div>
            <div class="a mb-2" *ngIf="showTimer && showAd">
                <a class="text-center" *ngIf="!router.url.includes('/preview')" [href]="selectedAdData"
                    target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i
                        class="fa fa-external-link fs-9 ml-1"></i></a>
                <a class="text-center" *ngIf="router.url.includes('/preview')"
                    class="mr-2 text-white text-decoration-none slick-disabled">Learn more <i
                        class="fa fa-external-link fs-9 ml-1"></i></a>
            </div>
            <button class="close-button" aria-label="Close alert" type="button" data-close
                *ngIf="showTimer && showAd" (click)="closeAdd()">

                <span aria-hidden="true">{{secondsData}}<span class="ml-1"><i
                            class="fa fa-step-forward"></i></span></span></button>
        </div>
    </div> -->
            </div>

            <!-- ---------------- Video List -------------------- -->
            <div [hidden]="tag_category != 'video'" class="table-responsive table-custom-style p-25"
                [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null  }">

                <table mat-table [dataSource]="dataSourceVideo" class="w-100 mb-180"
                    [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null  }">

                    <ng-container matColumnDef="Thumbnail" class="">
                        <th mat-header-cell *matHeaderCellDef class="pl-15 "> Thumbnail </th>
                        <td mat-cell *matCellDef="let element;" class="pl-15 width-row p-10 d-none d-md-table-cell ">
                            <div class="video-thumb" *ngIf="element?.stream_info?.video_thumbnail_image"
                                [ngStyle]="{'background-image': 'url('+element?.stream_info?.video_thumbnail_image+')','background-color':settingsData.bg_secondary_color }">
                            </div>
                            <div *ngIf="!element || !element.stream_info  || !element.stream_info.video_thumbnail_image"
                                class="video-thumb"
                                [ngStyle]="{'background-image': ' url(' + video_banner_image + ')','background-color':settingsData.bg_secondary_color }"></div>
                            <!-- <img *ngIf="element?.stream_info?.video_thumbnail_image" src="{{element?.stream_info?.video_thumbnail_image}}" class="thumb-img video-thumb d-none d-md-inline-block">
                <img *ngIf="!element || !element.stream_info  || !element.stream_info.video_thumbnail_image" src="assets/album-video.png" class="thumb-img video-thumb "> -->
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Play">
                        <th mat-header-cell *matHeaderCellDef> Play </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="pl-2 plr-0 width-row">
                            <!-- <ng-container *ngIf="(!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
                    element.stream_info.stream_payment_mode == 'free_ads' || element.isSubscribed) && !router.url.includes('/preview')">
                    <div class="media-ply-stop-btn pointer ml-20">
                        <i class="fa fa-play player-icon play-icon" aria-hidden="true" (click)="openModalWithClass(template,element.stream_info)"
                            [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }"></i>
                    </div>
                </ng-container> -->
                            <!-- Video play button -->
                            <!-- Audio timer button if timer is not running -->
                            <div class="media-ply-stop-btn m-auto" *ngIf="!showCountDownTimer">
                                <ng-container *ngIf="(!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
                            element.stream_info.stream_payment_mode == 'free_ads' || element.isSubscribed || element.isPurchased) && !router.url.includes('/preview')
                            || (element.stream_info.stream_payment_mode == 'paid' && element.isPurchased)
                            || (streamInfo.stream_payment_mode=='paid' && !showAlbumPaymentButton)
                            || (streamInfo.stream_payment_mode=='subscription' && !showAlbumSubscriptionButton)">
                                    <div class="media-ply-stop-btn pointer" id="playVideo{{element.stream_info.id}}"
                                        (click)="openModalWithClass(template,element)">
                                        <i class="fa fa-play player-icon play-icon" aria-hidden="true"></i>
                                    </div>
                                </ng-container>
                                <ng-container
                                    *ngIf="(!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
                                element.stream_info.stream_payment_mode == 'free_ads' || element.isSubscribed) && router.url.includes('/preview')">
                                    <div class="media-ply-stop-btn">
                                        <i class="fa fa-play player-icon play-icon slick-disabled" aria-hidden="true"></i>
                                    </div>
                                </ng-container>
                                <ng-container
                                    *ngIf="element.stream_info.stream_payment_mode == 'paid' && !element.isPurchased && router.url.includes('/preview')">
                                    <!-- <img [src]="assets_url+'channel-album/single-pay.svg'" class="slick-disabled"> -->
                                    <span class="slick-disabled dollar-icon">
                                        <app-svg [icon]="'channel-album-single-pay'" [color]="i % 2 == 0 ? settingsData?.font_tertiary_color : settingsData?.bg_tertiary_color"></app-svg>
                                    </span>
                                </ng-container>
                                <!-- Video payment button -->
                                <ng-container *ngIf="element.stream_info.stream_payment_mode == 'paid' && !element.isPurchased && !router.url.includes('/preview')
                            && !(streamInfo.stream_payment_mode=='paid'&& !showAlbumPaymentButton)
                            ">
                                    <!-- <img [src]="assets_url+'channel-album/single-pay.svg'" class="pointer"
                                id="playVideo{{element.stream_info.id}}" (click)="openVideoAudioPayment(element)"> -->
                                    <span class="pointer dollar-icon" id="playVideo{{element.stream_info.id}}"
                                        (click)="openVideoAudioPayment(element)">
                                        <app-svg [icon]="'channel-album-single-pay'" [color]="i % 2 == 0 ? settingsData?.font_tertiary_color : settingsData?.bg_tertiary_color"></app-svg>
                                        <span class="track-price" *ngIf="element | vdTrackPrice: tickets as price">{{ price }}</span>
                                    </span>
                                </ng-container>
                                <ng-container
                                    *ngIf="element.stream_info.stream_payment_mode == 'subscription' && router.url.includes('/preview')">
                                    <div class="media-ply-stop-btn" >
                                        <i class="fa fa-hand-o-up player-icon play-icon pl-0 slick-disabled"
                                            aria-hidden="true" ></i>
                                    </div>
                                </ng-container>
                                <!-- Video subscription button -->
                                <ng-container *ngIf="(element.stream_info.stream_payment_mode == 'subscription' && !element.isSubscribed && !element.planNotSuff && !router.url.includes('/preview'))
                            && !(streamInfo.stream_payment_mode=='subscription'&&!showAlbumSubscriptionButton)
                            && !(streamInfo.stream_payment_mode=='paid'&& !showAlbumPaymentButton)
                            ">
                                    <div class="media-ply-stop-btn" >
                                        <i class="fa fa-hand-o-up player-icon play-icon pl-0" aria-hidden="true"
                                            id="playVideo{{element.stream_info.id}}"
                                            (click)="doSubscribePayment(element,true)"
                                            ></i>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="element.stream_info.stream_payment_mode == 'subscription' && element.planNotSuff && subscribedUserPlans.length > 0 && !router.url.includes('/preview')
                            && !(streamInfo.stream_payment_mode=='subscription'&&!showAlbumSubscriptionButton)
                            && !(streamInfo.stream_payment_mode=='paid'&& !showAlbumPaymentButton)
                            ">
                                    <!-- (click)="doSubscribePayment(element)" -->
                                    <div class="media-ply-stop-btn" >
                                        <i class="fa fa-hand-o-up player-icon play-icon slick-disabled pl-0"
                                            aria-hidden="true"
                                            matTooltip="Your current subscription plan is not sufficient for this video"
                                            matTooltipPosition='above' id="playVideo{{element.stream_info.id}}"></i>
                                    </div>
                                </ng-container>
                                <!-- Video folder button -->
                                <ng-container *ngIf="(streamInfo.stream_payment_mode=='paid'
                            && showAlbumPaymentButton && element.stream_info.stream_payment_mode == 'folder')">
                                    <div class="media-ply-stop-btn">
                                        <i class="fa fa-play player-icon play-icon slick-disabled" aria-hidden="true"
                                            matTooltip="Complete album payment to play the video"
                                            matTooltipPosition='above'></i>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Video timer button if timer is running -->
                            <div class="media-ply-stop-btn m-auto" *ngIf="showCountDownTimer">
                                <i class="fa fa-clock-o player-icon clock-icon" aria-hidden="true"
                                    matTooltip="Sale not started yet" matTooltipPosition='above'></i>
                            </div>
                            <!-- Video buttons end here -->
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Album">
                        <th mat-header-cell *matHeaderCellDef> Album </th>
                        <td mat-cell *matCellDef="let element">
                            <span>
                                {{element?.stream_info?.stage}}
                            </span>
                            <span class="d-block fs-12">
                                Age Limit : {{element?.stream_info?.ageInfo}}
                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Mintues">
                        <th mat-header-cell *matHeaderCellDef> Mintues </th>
                        <td mat-cell *matCellDef="let element" class="mintues-width-row">
                            <span class="mr-20">
                                {{element?.stream_info?.duration}}
                            </span>
                            <div class="dropdown d-inline-block playlist-dd" *ngIf="userInfo.access_token && ((!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
                element.stream_info.stream_payment_mode == 'free_ads' || element.isSubscribed || element.isPurchased) && !router.url.includes('/preview')
                || (element.stream_info.stream_payment_mode == 'paid' && element.isPurchased)
                || (streamInfo.stream_payment_mode=='paid'&& !showAlbumPaymentButton)
                || (streamInfo.stream_payment_mode=='subscription'&& !showAlbumSubscriptionButton))">
                                <button class="btn btn-secondary plus-icon mr-15" id="dropdownMenu2"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                    [ngStyle]="{'background-color':settingsData?.bg_secondary_color,'color':settingsData?.font_primary_color}">
                                    <span class="plus-text"
                                        matTooltip="Add to playlist" matTooltipPosition="above">+</span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right" [ngStyle]="{'background-color':settingsData?.form_bg_color , 'color':settingsData?.form_font_secondary_color}"
                                 aria-labelledby="dropdownMenu2">
                                    <div class="dropdown-item pointer"
                                        (click)="createPlayList('video')">Create New Playlist</div>
                                    <div class="creatediv" *ngIf="playListAry && playListAry.length > 0">
                                        <ng-container *ngFor="let playList of playListAry" >
                                            <div class="dropdown-item pointer"
                                                [ngStyle]="{'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : null }"
                                                (click)="addToPlayList(element, playList)">{{playList.playlist_name}}
                                            </div>
                                        </ng-container>
                                    </div>

                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Views">
                        <th mat-header-cell class="w-80p" *matHeaderCellDef> Views </th>
                        <td mat-cell class="text-center width-views" *matCellDef="let element; let i=index">
                            <div class="text-center row no-gutters w-100 mt-15 like-share-icons"
                                style="position: relative;">
                                <span class="col-4">
                                    <div class="fs-20"><i class="fa fa-eye"></i></div>
                                    <div class="fs-12" matTooltip="{{element.stream_info['user_views']| number }} views"
                                        matTooltipPosition="above">
                                        <span *ngIf="element.stream_info && element.stream_info['user_views']>=0">
                                            {{element.stream_info['user_views'] | abbreviatedNumber}}
                                        </span>
                                    </div>
                                </span>
                                <span class="pointer col-4" *ngIf="!showCountDownTimer">
                                    <div class="fs-20"
                                        (click)="userInfo && userInfo.access_token ? likeAudioVideo(element,i): requireLogin()"
                                        matTooltip="Like" matTooltipPosition="above"
                                        [matTooltipDisabled]="element['stream_info'].is_liked == 1">
                                        <i class="fa fa-thumbs-up"
                                            [ngStyle]="{'color': (element['stream_info'].is_liked == 1) ? themeColors.primaryColor : themeColors.secondaryFontColor }"></i>
                                    </div>
                                    <div class="fs-12"
                                        [ngStyle]="{'color': (element['stream_info'].is_liked == 1) ? themeColors.primaryColor : themeColors.secondaryFontColor }">
                                        <span *ngIf="element.stream_info && element.stream_info['user_likes']>=0">
                                            {{element.stream_info['user_likes'] | abbreviatedNumber}}
                                        </span>
                                    </div>
                                </span>
                                <span class="pointer col-4" (click)="shareVideo(element)"
                                    (click)="$event.stopPropagation()">
                                    <div class="fs-20"><i class="fa fa-share-alt"
                                            [ngStyle]="{'color': element.shareSubEvent? themeColors.primaryColor : themeColors.secondaryFontColor }"></i>
                                    </div>
                                    <div class="fs-12"
                                        [ngStyle]="{'color': element.shareSubEvent ? themeColors.primaryColor : themeColors.secondaryFontColor }">
                                        Share</div>
                                </span>
                                <div *ngIf="element.shareSubEvent" #menu class="social-icons-div"
                                    (click)="$event.stopPropagation()">
                                    <app-social-share-link [slugName]="router.url+'?id='+element.stream_info.id"
                                        [sharedFrom]="'album'" [settingsData]="settingsData ? settingsData :'' " (closeShareEvent)="closeSocialSharePopup($event)">
                                    </app-social-share-link>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Menu">
                        <th mat-header-cell class="w-80p" *matHeaderCellDef> Menu </th>
                        <td mat-cell class="w-80p text-right" *matCellDef="let element; let i=index">
                            <span class="pointer menu-div" (click)="$event.stopPropagation()">
                                <div mat-icon-button [ngClass]="{'slick-disabled':router.url.includes('/preview')}">
                                    <mat-icon class="mt-5" (click)="openMenu(i, element.openMenu)">more_vert</mat-icon>
                                    <div class="main-menu" (click)="reportFileData(element, 'uploadedVideo')"
                                        *ngIf="element.openMenu"
                                        [ngStyle]="{'background-color':settingsData?.form_bg_color , 'color':settingsData?.form_font_secondary_color}">
                                        <div class="plr-10">Report</div>
                                        <div class="plr-10"><i class="fa fa-flag"></i></div>
                                    </div>
                                </div>
                            </span>
                        </td>
                    </ng-container>

                    <!-- <tr mat-header-row *matHeaderRowDef="displayedColumnsVideo" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                    'font-family': settingsData.font_family ? settingsData.font_family : null  }"></tr> -->
                    <ng-container *ngIf="false">
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsVideo" 
                            [ngStyle]="{
                              'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null,
                              'color': settingsData.font_primary_color ? settingsData.font_primary_color : null,
                              'font-family': settingsData.font_family ? settingsData.font_family : null
                            }">
                        </tr>
                      </ng-container>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsVideo;let i = index;" 
                    [style.background-color]="(i % 2 == 0 ? settingsData.bg_tertiary_color : settingsData.font_tertiary_color) + ' !important'"
                    [style.color]="(i % 2 == 0 ? settingsData.font_tertiary_color : settingsData.bg_tertiary_color) + ' !important'"
                    [style.font-family]="(settingsData.font_family || 'inherit') + ' !important'">
                    </tr>
                </table>
            </div>


            <!-- ---------------- Recorded videos List -------------------- -->
            <div [hidden]="tag_category != 'recorded-video'" class="table-responsive table-custom-style  p-25"
                [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null  }">
                <table mat-table [dataSource]="dataSourceRecVideo" class="w-100 mb-180"
                    [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null  }">

                    <ng-container matColumnDef="Thumbnail" class="">
                        <th mat-header-cell *matHeaderCellDef class="pl-15 "> Thumbnail </th>
                        <td mat-cell *matCellDef="let element;" class="pl-15 width-row p-10 d-none d-md-table-cell ">
                            <div class="video-thumb" *ngIf="element?.stream_info?.video_thumbnail_image"
                                [ngStyle]="{'background-image': 'url('+element?.stream_info?.video_thumbnail_image+')'}">
                            </div>
                            <div *ngIf="!element || !element.stream_info  || !element.stream_info.video_thumbnail_image"
                                class="video-thumb"
                                [ngStyle]="{'background-image': ' url(' + video_banner_image + ')'}"></div>
                            <!-- <img *ngIf="element?.stream_info?.video_thumbnail_image" src="{{element?.stream_info?.video_thumbnail_image}}" class="thumb-img video-thumb d-none d-md-inline-block">
                <img *ngIf="!element || !element.stream_info  || !element.stream_info.video_thumbnail_image" src="assets/album-video.png" class="thumb-img video-thumb "> -->
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Play">
                        <th mat-header-cell *matHeaderCellDef> Play </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="pl-2 plr-0 width-row">
                            <ng-container
                                *ngIf="((element.stream_info.stream_payment_mode !='paid' && tickets.length > 0) || ticket_ids.indexOf(element.stream_info.id) != -1 || ticket_ids.indexOf(element.stream_info.parent_streams_id) != -1);else buyTicket">
                                <ng-container *ngIf="!router.url.includes('/preview')">
                                    <div class="media-ply-stop-btn pointer" id="playVideo{{element.stream_info.id}}"
                                        (click)="openModalWithClass(template,element)">
                                        <i class="fa fa-play player-icon play-icon" aria-hidden="true"
                                            ></i>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="router.url.includes('/preview')">
                                    <div class="media-ply-stop-btn">
                                        <i class="fa fa-play player-icon play-icon slick-disabled" aria-hidden="true"
                                            ></i>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <ng-template #buyTicket>
                                <ng-container
                                    *ngIf="element.stream_info.stream_payment_mode == 'paid' && tickets.length >= 0 && router.url.includes('/preview')">
                                    <!-- <img [src]="assets_url+'channel-album/single-pay.svg'" class="slick-disabled"> -->
                                    <span class="slick-disabled dollar-icon">
                                        <app-svg [icon]="'channel-album-single-pay'" [color]="i % 2 == 0 ? settingsData?.font_tertiary_color : settingsData?.bg_tertiary_color">
                                        </app-svg>
                                    </span>
                                </ng-container>
                                <ng-container
                                    *ngIf="element.stream_info.stream_payment_mode == 'paid' && tickets.length >= 0 && !router.url.includes('/preview')">
                                    <!-- <img [src]="assets_url+'channel-album/single-pay.svg'" class="pointer"
                            id="playVideo{{element.stream_info.id}}" (click)="redirectTo(element)"> -->
                                    <span class="pointer dollar-icon" id="playVideo{{element.stream_info.id}}"
                                        (click)="redirectTo(element)">
                                        <app-svg [icon]="'channel-album-single-pay'" [color]="i % 2 == 0 ? settingsData?.font_tertiary_color : settingsData?.bg_tertiary_color"></app-svg>
                                        <span class="track-price" *ngIf="element | vdTrackPrice: tickets as price">{{ price }}</span>
                                    </span>
                                </ng-container>
                            </ng-template>

                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Album">
                        <th mat-header-cell *matHeaderCellDef> Album </th>
                        <td mat-cell *matCellDef="let element" class="p-5"
                        [style.background-color]="(i % 2 == 0 ? settingsData.bg_primary_color : settingsData.bg_secondary_color) + ' !important'"
                        [style.color]="settingsData.font_primary_color + ' !important'">
                            <!-- <span
                                [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }">
                                {{element?.stream_info?.stage}}
                            </span>
                            <span class="d-block fs-12 pt-5"
                                [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }">
                                Age Limit : {{element?.stream_info?.ageInfo}}
                            </span> -->
                            <span>{{element?.stream_info?.stage}}</span>
                            <span class="d-block fs-12 pt-5"> Age Limit : {{element?.stream_info?.ageInfo}}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Minutes">
                        <th mat-header-cell *matHeaderCellDef> Minutes </th>
                        <td mat-cell *matCellDef="let element" class="mintues-width-row">
                            <div class="dropdown d-inline-block playlist-dd ml-3"
                                *ngIf="userInfo.access_token && (element.stream_info.stream_payment_mode !='paid' || ticket_ids.indexOf(element.stream_info.id) != -1 || ticket_ids.indexOf(element.stream_info.parent_streams_id) != -1) && !router.url.includes('/preview')">
                                <button class="btn btn-secondary plus-icon" type="button" id="dropdownMenu2"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                    [ngStyle]="{'background-color':settingsData?.bg_secondary_color,'color':settingsData?.font_primary_color}">
                                    <span class="plus-text"
                                        [ngStyle]="{'color': settingsData.font_secondary_color ? settingsData.font_secondary_color : null }"
                                        matTooltip="Add to playlist" matTooltipPosition="above">+</span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right " aria-labelledby="dropdownMenu2" [ngStyle]="{'background-color':settingsData?.form_bg_color , 'color':settingsData?.form_font_secondary_color}">
                                    <div class="dropdown-item " type="button"
                                        [ngStyle]="{'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : null,'border-bottom': '1px solid' ,'border-color': settingsData.font_secondary_color ? settingsData.font_secondary_color : '#fff' }"
                                        (click)="createPlayList('video')">Create New Playlist</div>
                                    <div class="creatediv" *ngIf="playListAry && playListAry.length > 0">
                                        <ng-container *ngFor="let playList of playListAry">
                                            <div class="dropdown-item" type="button"
                                                [ngStyle]="{'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : null }"
                                                (click)="addToPlayList(element, playList)">{{playList.playlist_name}}
                                            </div>
                                        </ng-container>
                                    </div>

                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Menu">
                        <th mat-header-cell class="w-80p" *matHeaderCellDef> Menu </th>
                        <td mat-cell class="w-80p text-right" *matCellDef="let element; let i = index">
                            <span class="pointer menu-div" (click)="$event.stopPropagation()">
                                <div mat-icon-button [ngClass]="{'slick-disabled':router.url.includes('/preview')}">
                                    <mat-icon class="mt-5" (click)="openMenu(i, element.openMenu)">more_vert</mat-icon>
                                    <div class="main-menu" (click)="reportFileData(element, 'recordedVideo')"
                                        *ngIf="element.openMenu"
                                        [ngStyle]="{'background-color':settingsData?.form_bg_color , 'color':settingsData?.form_font_secondary_color}">
                                        <div class="plr-10">Report</div>
                                        <div class="plr-10"><i class="fa fa-flag"></i></div>
                                    </div>
                                </div>
                            </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsRecVideo" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                    'font-family': settingsData.font_family ? settingsData.font_family : null  }"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsRecVideo;let i = index;"
                     [style.background-color]="(i % 2 == 0 ? settingsData.bg_tertiary_color : settingsData.font_tertiary_color) + ' !important'"
                    [style.color]="(i % 2 == 0 ? settingsData.font_tertiary_color : settingsData.bg_tertiary_color) + ' !important'"
                    [style.font-family]="(settingsData.font_family || 'inherit') + ' !important'"></tr>
                </table>
                <!-- <div class="row pr-0 pl-0 mt-30">
        <div class="col-12">
            <div *ngFor="let subEvent of sortedEventsData; let i = index;let even = even; let odd = odd">
                <ng-container *ngIf="subEvent?.isMatched">
                    <div class="row no-gutters">
                        <div class="col-12 col-sm-12 col-lg-2 col-md-12 text-right mtext-right p-20 pl-0">
                            <p class="mfs-11 notranslate">
                                {{subEvent.stream_info.startTime}}
                                -
                                {{subEvent.stream_info.endTime}}
                            </p>
                        </div>
                        <div class="col-12 col-sm-12 mb-15 col-lg-10 col-md-12"
                            [ngClass]="{ 'bg-primary-even': even, 'bg-primary-odd': odd}">
                            <div class="row no-gutters p-20">
                                <div class="agenda-block col-12 col-md-9 col-lg-9 pl-0">
                                    <h5 class="fs-16">{{subEvent.stream_info.stage}}</h5>
                                    <p class="text-primary"
                                        [innerHTML]="subEvent.stream_info.stream_video_description | safe: 'html'">
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div> -->
            </div>
            <div class="rightsidenav" *ngIf="showTicketsList">
                <div class="top-line-bg">
                    <span> Tickets </span>
                    <!-- <img class="close-icon-subscribe" [src]="assets_url+'Live-Stream-assets/close-icon-white.svg'"
            (click)="closeTicketsMenu()"> -->
                    <span class="close-icon-subscribe" (click)="closeTicketsMenu()"
                        [ngClass]="{'d-none' : activatedRoute?.snapshot?.queryParams?.user_id}">
                        <app-svg [icon]="'live-stream-close-icon-white'"></app-svg>
                    </span>
                </div>
                <div class="p-15">
                    <div class=" tickets-div br-4 mb-10" *ngFor="let ticket of selectedStageTickets"
                        [ngStyle]="{'background-color': settingsData.bg_secondary_color ? settingsData.bg_secondary_color : null, 'font-family': settingsData.font_family ? settingsData.font_family : null  }">
                        <div class="row align-items-center no-gutters p-10">
                            <div class="col-6">
                                <div class="ticket_name font-data"
                                    [ngStyle]="{'color': settingsData.font_primary_color ? settingsData.font_primary_color : null }">
                                    {{ticket.title}}</div>
                                <div class="amount font-data"
                                    [ngStyle]="{'color': settingsData.font_primary_color ? settingsData.font_primary_color : null }">
                                    {{ticket?.price |
                                    currency:
                                    ticket?.currency}}</div>
                            </div>
                            <div class="col-6 text-right">
                                <button class="btn flat-primary-button" (click)="selectTicket(ticket)" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                    'font-family': settingsData.font_family ? settingsData.font_family : null  }">select</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Subscriptions List -->
            <div *ngIf="isShownSideBar" class="rightsidenav" [ngStyle]="{'background-color':settingsData.form_bg_color?settingsData.form_bg_color:''}">
                <div class="top-line-bg" [ngStyle]="{'background-color':settingsData.form_bg_color?settingsData.form_bg_color:''}">
                    <span> Subscribe </span>
                    <!-- <img class="close-icon-subscribe" [src]="assets_url+'Live-Stream-assets/close-icon-white.svg'"
            (click)="openSubscribeSideMenu()"> -->
                    <span class="close-icon-subscribe" (click)="openSubscribeSideMenu()"
                        [ngClass]="{'d-none' : activatedRoute?.snapshot?.queryParams?.user_id}">
                        <app-svg [icon]="'live-stream-close-icon-white'"></app-svg>
                    </span>
                    <app-subscription-list [planIds]="planIds" [creatorCurrency]="creatorCurrency">
                    </app-subscription-list>
                </div>
            </div>


            <div *ngIf="isPaymentShow" class="rightsidenav" [ngStyle]="{'background-color':settingsData.form_bg_color?settingsData.form_bg_color:'',
'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                <div class="top-line-bg " [ngStyle]="{'background-color':settingsData.form_bg_color?settingsData.form_bg_color:'',
    'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                    <div class="row no-gutters align-items-center">
                        <div class="col-8">
                            <div class="d-inline-block"
                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-size': settingsData.form_fs_main_title ? settingsData.form_fs_main_title: ''}">
                                Payment
                            </div>
                        </div>
                        <div class="col-4 text-right">
                            <i class="fa fa-times-circle-o fs-24 pointer"
                                [ngClass]="{'d-none' : activatedRoute?.snapshot?.queryParams?.user_id}"
                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' }"
                                (click)="togglePaymentSideMenu()"></i>
                        </div>
                    </div>
                    <app-ic-media-payment (togglePaymentSideMenu)="togglePaymentSideMenu($event)"
                        [settingsData]="settingsData" [screenFrom]="'directive'" [tickets]="tickets"
                        [paymentStreamInfo]="paymentStreamInfo" [performer_details]="performer_details">
                    </app-ic-media-payment>
                </div>
            </div>

        </div>


        <div class="app-album-list  d-inline" *ngIf="!is_can_see_album">
            <div class="album-box" style="min-height: 700px;"
                [ngStyle]="{'background-color': settingsData.bg_secondary_color ? settingsData.bg_secondary_color : null, 'font-family': settingsData.font_family ? settingsData.font_family : null  }">

                <div fxLayout="row wrap" fxFlex="100%" fxLayoutAlign="center center">
                    <div fxFlex="100%" fxLayoutAlign="center center" class="fs-18"
                        [ngStyle]="{'color': settingsData.font_primary_color ? settingsData.font_primary_color : null }">
                        Album list not available for the {{currentLocation.country_name}}
                    </div>
                    <div fxFlex="100%" fxLayoutAlign="center center" class="mt-10 pointer" (click)="goToGener()"
                        [ngStyle]="{'color': settingsData.font_primary_color ? settingsData.font_primary_color : null }">
                        Go To Home
                    </div>
                </div>
            </div>
        </div>

        <ng-template #template>

            <div class="modal-body album-videos">
                <div [hidden]="!showAd" class="full-page-ad text-center">
                    <div class="ablum-ads" data-closable>
                        <div [innerHTML]="adVideo" alt=' ' title=' ' class="ad bg-dark" *ngIf="showAd"></div>
                        <div class="a mb-2" *ngIf="showTimer && showAd"><a class="text-center" [href]="selectedAdData"
                                target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i
                                    class="fa fa-external-link fs-9 ml-1"></i></a></div>
                        <button class="close-button" aria-label="Close alert" type="button" data-close
                            *ngIf="showTimer && showAd" (click)="closeAdd()">

                            <span aria-hidden="true">{{secondsData}}<span class="ml-1"><i
                                        class="fa fa-step-forward"></i></span></span></button>
                    </div>
                </div>
                <!-- <video id="video" src="{{videoURL}}" style="height: 100%;width: 100%;" controls autoplay class="z-9 video-on-img"></video> -->
                <!-- <div *ngIf="!showAd">
            <div class="album-video-title-box">
                <div class="album-video-title"> {{selectedVideo?.stage}} </div>
                <div class="report-btn album-video-title"  *ngIf="!router.url.includes('/preview')"
                [matMenuTriggerFor]="reportMenu"
                (click)="$event.stopPropagation()"
                (click) ="reportFileData(selectedVideo, 'playerVideo')"
                matTooltipPosition="below" matTooltip="Report Abuse"
                [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                >
                <i class="fa fa-flag"></i>
                </div>
                <div class="close-btn album-video-title" (click)="close()">
                    <img src="assets/Live-Stream-assets/close-icon-white.svg">
                </div>
            </div>
            <mat-menu #reportMenu="matMenu" *ngIf="!router.url.includes('/preview')" class="report-panel" (click)="$event.stopPropagation();">
                <app-report></app-report>
            </mat-menu>
            <m3u8-video id="uploadedVideoPlayer" (timeupdate) = "getCurrentTime($event)" [videoUrl]="videoURL" [openFrom]="'VideoAlbum'" [start_live_diff]="selectedStreamInfo.start_live_diff" autoplay></m3u8-video>
        </div> -->

                <!-- solved for preprod report abuse while playing audio.. by srikanth-->
                <div *ngIf="!showAd">
                    <div class="album-video-title-box">
                        <div class="album-video-title"> {{selectedVideo?.stage}} </div>
                        <ng-container *ngIf="!router.url.includes('/preview')">
                            <div class="report-btn album-video-title"
                                (click)="reportFileData(selectedVideo, 'playerVideo')" matTooltipPosition="below"
                                matTooltip="Report Abuse"
                                [ngClass]="{'slick-disabled':router.url.includes('/preview')}">
                                <i class="fa fa-flag"></i>
                            </div>
                        </ng-container>
                        <div class="close-btn album-video-title" (click)="close()">
                            <!-- <img [src]="assets_url+'Live-Stream-assets/close-icon-white.svg'"> -->
                            <app-svg [icon]="'live-stream-close-icon-white'"></app-svg>
                        </div>
                    </div>
                    <m3u8-video id="uploadedVideoPlayer" (timeupdate)="getCurrentTime($event)" [videoUrl]="videoURL"
                        [openFrom]="'VideoAlbum'" [start_live_diff]="selectedStreamInfo.start_live_diff" autoplay>
                    </m3u8-video>
                </div>

            </div>
        </ng-template>
        <button matTooltip="Subscribe" matTooltipPosition='left' [ngClass]="{'show-scroll': showScroll}"
            *ngIf="!isSubscribed && !settingsData.is_preview && !router.url.includes('/preview')" mat-button
            class="subscribe-btns scroll-to-top" (click)="doSubscribePayment(subEvents[0],true)" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,
        'color': settingsData.font_primary_color ? settingsData.font_primary_color : null , 'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null ,
        'font-family': settingsData.font_family ? settingsData.font_family : null  }">
            <i class="fa fa-hand-o-up player-icon play-icon pl-0" aria-hidden="true" [ngStyle]="{'color':settingsData?.font_primary_color}"></i>
        </button>